import React from 'react';
import SectionCard from './SectionCard';
import { profileData, skillsData } from '../data/mock';
import { useLanguage } from '../context/LanguageContext';

const ContactSection = ({ isDoorOpen }) => {
  const { t, language } = useLanguage();

  return (
    <SectionCard
      id="contact"
      icon="📬"
      title={t.contact.title}
      subtitle={t.contact.subtitle}
      isDoorOpen={isDoorOpen}
    >
      <div className="contact-info">
        <p><strong>{t.contact.email}:</strong> <a href={`mailto:${profileData.email}`}>{profileData.email}</a></p>
        <p><strong>{t.contact.languages}:</strong> {skillsData.languages.map(l => l.name).join(', ')}.</p>
        <p><strong>{t.contact.location}:</strong> {profileData.location[language]}</p>
      </div>
    </SectionCard>
  );
};

export default ContactSection;
